"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packInstrData = exports.InstructionType = void 0;
var InstructionType;
(function (InstructionType) {
    InstructionType[InstructionType["RAYDIUM_SWAP"] = 0] = "RAYDIUM_SWAP";
    InstructionType[InstructionType["TRANSFER"] = 1] = "TRANSFER";
    InstructionType[InstructionType["SOLEND_LIQUIDITY_DEPOSIT"] = 2] = "SOLEND_LIQUIDITY_DEPOSIT";
    InstructionType[InstructionType["RAYDIUM_POOL_LIQUIDITY_DEPOSIT"] = 3] = "RAYDIUM_POOL_LIQUIDITY_DEPOSIT";
    InstructionType[InstructionType["RAYDIUM_POOL_LIQUIDITY_STAKE"] = 4] = "RAYDIUM_POOL_LIQUIDITY_STAKE";
})(InstructionType = exports.InstructionType || (exports.InstructionType = {}));
const packInstrData = (data, instr) => {
    const uint8 = new Uint8Array([instr, ...data]);
    return Buffer.from(uint8);
};
exports.packInstrData = packInstrData;
